import React from 'react'

import { Icon, Tag, type TagProps, Tooltip } from '@fourthwall/components'
import { QuestionMarkIcon } from '@fourthwall/icons'

import type { DomainStatus } from '../../CustomDomain.types'
import * as S from './DomainStatusTag.styled'

type DomainStatusTagProps = {
  status: DomainStatus
}

export const tagPropsMap: Record<DomainStatus, TagProps> = {
  REMOVAL_IN_PROGRESS: { label: 'Removal in progress', appearance: 'critical' },
  SYNCING_YOUR_DOMAIN: { label: 'Syncing your domain', appearance: 'default' },
  CONNECTED: { label: 'Connected', appearance: 'success' },
  PARTIALLY_CONNECTED: { label: 'Partially Connected', appearance: 'success' },
  NOT_CONNECTED: { label: 'Not connected', appearance: 'alert' },
  CONNECTING: { label: 'Connecting', appearance: 'alert' },
}

export const DomainStatusTag = ({ status }: DomainStatusTagProps) => {
  const tagProps = tagPropsMap[status]

  return (
    <S.Container>
      <Tag {...tagProps} />
      {status === 'REMOVAL_IN_PROGRESS' && (
        <Tooltip
          reference={<Icon component={QuestionMarkIcon} height={18.75} />}
          placement="top"
          fluid
        >
          This process usually takes a couple of seconds
        </Tooltip>
      )}
    </S.Container>
  )
}
